import { defineMessages } from 'react-intl'

const scope = `procurify.components.DataTable.ItemDescriptionQuantityCell`

export default defineMessages({
  quantityLabel: {
    id: `${scope}.quantityLabel`,
    defaultMessage: 'Quantity',
  },
  differentVendorTooltip: {
    id: `${scope}.differentVendorTooltip`,
    defaultMessage: 'Item requested from a different vendor',
  },
  differentVendorIconAriaLabel: {
    id: `${scope}.differentVendorIconAriaLabel`,
    defaultMessage: 'Different vendor selected warning icon',
  },
})
